import React from "react";
import PropTypes from "prop-types";

const LockedButton = props => (
  <button
    type="button"
    className={"btn btn-edit ic-lock-btn " + props.className}
    onClick={props.onClick}
  >
    <i className="fas fa-lock" />
  </button>
);

export default LockedButton;

LockedButton.defaultProps = {
  className: "",
  onClick: () => {}
};

LockedButton.prototype = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
